export function joinUrl(...urlComponents) {
    return urlComponents
        .map((url, urlIndex) => {
        let adjustedUrl = url;
        // not the last item
        if (urlIndex !== urlComponents.length) {
            // remove trailing slash
            if (adjustedUrl[adjustedUrl.length - 1] === "/") {
                adjustedUrl = adjustedUrl.slice(0, -1);
            }
        }
        // not the first item
        if (urlIndex !== 0) {
            // remove leading slash
            if (adjustedUrl[0] === "/") {
                adjustedUrl = adjustedUrl.slice(1);
            }
        }
        return adjustedUrl;
    })
        .join("/");
}
//# sourceMappingURL=joinUrl.js.map